import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Transparencia/transparencia.css';
import { InformacionInstitucional_item } from '../../json/informacionInstitucionalItems';

const InformacionInstitucional = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
  return (
    <div className='container transparencia-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='transparencia_title'>
                    <h1>Información Institucional</h1>
                </div>
            </div>
        </div>
        <div className='row'>
            {
                InformacionInstitucional_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 transparencia_item'>
                        <Link to={ item.InformacionInstitucional_item_url }>{ item.InformacionInstitucional_item_nombre }</Link>
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default InformacionInstitucional